import { useState } from "react";
import { LuTruck, LuEye } from "react-icons/lu";
import Modal from "../../../common/Modal";

const PAGE_SIZE = 5;

export default function DelayedOrdersTable({ items = [], loading }) {
  const [page, setPage] = useState(1);
  const [activeGroup, setActiveGroup] = useState(null);

  const totalPages = Math.max(1, Math.ceil(items.length / PAGE_SIZE));
  const start = (page - 1) * PAGE_SIZE;
  const visible = items.slice(start, start + PAGE_SIZE);

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <div className="flex items-center gap-2">
          <LuTruck size={15} className="text-gray-400" />
          <h3 className="text-[13px] font-semibold text-gray-900">Delayed Orders</h3>
        </div>
        <span className="text-[11px] text-gray-400">{items.length} total</span>
      </div>

      {loading && (
        <div className="flex items-center justify-center py-10">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-700" />
        </div>
      )}

      {!loading && items.length === 0 && (
        <p className="px-4 py-8 text-center text-[12.5px] text-gray-400">
          No orders have been waiting over a month.
        </p>
      )}

      {!loading && items.length > 0 && (
        <>
          <div className="divide-y divide-gray-100">
            {visible.map((group) => (
              <div key={group.po} className="flex items-center justify-between gap-3 px-4 py-2.5">
                <div className="min-w-0">
                  <p className="truncate text-[12.5px] font-medium text-gray-800">
                    PO #{group.po} · <span className="text-gray-500">{group.supplier}</span>
                  </p>
                  <p className="truncate text-[11px] text-gray-400">
                    Ordered {new Date(group.orderDate).toLocaleDateString()} · {group.items.length}{" "}
                    {group.items.length === 1 ? "item" : "items"}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setActiveGroup(group)}
                  className="flex shrink-0 items-center gap-1 rounded-md border border-gray-200 px-2 py-1 text-[11.5px] font-medium text-gray-600 transition hover:bg-gray-50"
                >
                  <LuEye size={12} />
                  View
                </button>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex items-center justify-between border-t border-gray-100 px-4 py-2">
              <button
                type="button"
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
                className="text-[11.5px] font-medium text-gray-500 hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40"
              >
                Previous
              </button>
              <span className="text-[11px] text-gray-400">
                Page {page} of {totalPages}
              </span>
              <button
                type="button"
                disabled={page >= totalPages}
                onClick={() => setPage((p) => p + 1)}
                className="text-[11.5px] font-medium text-gray-500 hover:text-gray-800 disabled:cursor-not-allowed disabled:opacity-40"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}

      <Modal
        open={!!activeGroup}
        onClose={() => setActiveGroup(null)}
        title={activeGroup ? `Items in Purchase Order #${activeGroup.po}` : ""}
      >
        <div className="space-y-1.5">
          {activeGroup?.items.map((item) => (
            <div key={item.id} className="rounded-md border border-gray-100 px-3 py-2 text-[12.5px] text-gray-700">
              {item.item}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
}